<template>
  <div :data-id="`filter-input-${isUniversal ? 'universal' : index}`" :class="[{ 'mb-2': !isUniversal }, { 'is-active': isActive }, { disabled }]">
    <filter-boolean
      @apply-filter="applyFilter"
      v-if="isBooleanList || isSimplified"
      :field="field"
      :data-id="selectorId"
    />
    <filter-select
      @apply-filter="applyFilter"
      v-else-if="isSelect"
      :field="field"
      :list="field.list"
      :multiple="field.multiple"
      :panel-id="panelId"
      :data-id="selectorId"
    />
    <filter-date-time-control :field="field" v-else-if="isDate" :data-id="selectorId" />
    <filter-number @apply-filter="applyFilter" :data-id="selectorId" :field="field" v-else-if="isNumberInterval" />
    <filter-universal @apply-filter="applyFilter" v-else-if="isUniversal" :data-id="selectorId" />
    <filter-text @apply-filter="applyFilter" :field="field" v-else :data-id="selectorId" />
  </div>
</template>

<script>
import EventBus from '../../../utils/event-bus'
import FilterDateTimeControl from './FilterDateTimeControl'
import FilterNumber from './FilterNumber'
import FilterSelect from './FilterSelect'
import FilterText from './FilterText'
import FilterUniversal from './FilterUniversal'
import FilterBoolean from './FilterBoolean.vue'
import { get, isString } from 'lodash'
import { isSelect, toDropDownList, isDate, isSlider, isNumberInterval } from '../../../form'

export default {
  name: 'SearchControl',
  components: {
    FilterDateTimeControl,
    FilterNumber,
    FilterSelect,
    FilterText,
    FilterUniversal,
    FilterBoolean,
  },
  props: {
    index: {
      type: Number,
    },
    column: {
      type: String,
      default: '',
    },
    isUniversal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    columns() {
      return this.$get('columns')
    },
    columnType() {
      return get(this.field, 'filterFormat')
    },
    field() {
      return this.columns.find((column) => column.data === this.column)
    },
    id() {
      return this.$get('id')
    },
    isActive() {
      return this.searchParams.hasOwnProperty(this.column)
    },
    isBooleanList() {
      return get(this.field, 'isBooleanList', false) || this.isSimplified
    },
    isDate() {
      return isDate({ type: this.columnType })
    },
    isNumberInterval() {
      return isNumberInterval({ type: this.columnType }) || this.columnType === 'decimal-interval'
    },
    isSelect() {
      return isSelect({ type: this.columnType })
    },
    isSimplified() {
      return this.columnType === 'simplified'
    },
    panelId() {
      const _panelId = this.$get('panelId')
      return isString(_panelId) ? _panelId : null
    },
    searchParams() {
      return this.$get('searchParams')
    },
    selectorId() {
      return `${this.column}-search-control`
    }
  },
  methods: {
    applyFilter() {
      EventBus.$emit(`apply-filter-${this.id}`, { id: this.id })
    },
    isSlider,
    toDropDownList,
  },
}
</script>

<style lang="scss" scoped>
.is-active {
  box-shadow: 0 0 8px $color-not-set;
  border-radius: $default-border-radius;
}
.disabled {
  opacity: 0.5;
}
</style>
